<template>
	<div style="width:650px; height:745px;" v-on:keyup.esc="close()">
		<div class="left_option" style="padding-left:10px;padding-top:5px;">
			<span class="int_type" style="width:340px;">
				<AC ref="ac" :source="selectACItems" @selected="selectACItem" results-display="id_name" placeholder="Item / Name or ID"> </AC>
			</span>
			<a href="javascript:;" class="gray_bt2 mgr_10" @click="reset()">Reset</a>
			<span class="int_type">
				<input type="text" v-model.trim="keyword" class="tbl_int ssm2_int" placeholder="SN, BN or Amount to Filter" @focus="$event.target.select()" />
			</span>
		</div>
		<div class="view_inner">
			<div class="fixed-table-container" style="height:640px;">
				<div class="table-wrapper">
					<table id="item_list" class="list_tbl">
						<thead>
							<tr>
								<th style="text-align:center;width:20%;"><div class="th-text">Inv No</div></th>
								<th style="text-align:center;width:20%;"><div class="th-text">S/O No</div></th>
								<th style="text-align:center;width:20%;"><div class="th-text">Inv Date</div></th>
								<th style="text-align:center;width:20%;"><div class="th-text">Amount</div></th>
								<th style="text-align:center;width:20%;"><div class="th-text">Ship To</div></th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="invoice in filteredInvoices" v-bind:key="invoice.invoice_no" @dblclick="selectRow(invoice)">
								<td class="al_left">{{ invoice.invoice_dn }}</td>
								<td class="al_left">{{ invoice.so_dn }}</td>
								<td class="al_left">{{ invoice.invoice_date }}</td>
								<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
								<td class="al_left">{{ invoice.ship_to_code }}</td>
							</tr>
							<!-- <tr v-for="invoice in invoices" v-bind:key="invoice.invoice_no" @dblclick="selectRow(invoice)">
								<td>
									<font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.so_dn }}</font>
								</td>
								<td>{{ invoice.so_date }}</td>
								<td class="al_center">{{ invoice.status_code | saleStatusName }}</td>
								<td class="al_left">{{ invoice.ship_to_code }}</td>
								<td class="al_left truncate">{{ invoice.ship_to_name }}</td>
								<td class="al_left">{{ invoice.bill_to_code }}</td>
								<td class="al_left">{{ invoice.payment_term_code }}</td>
								<td class="al_left">{{ invoice.delivery_type_name }}</td>
								<td class="al_left">{{ invoice.sales_group_name }}</td>
								<td class="al_right">{{ invoice.total_quantity | commaSeparated }}</td>
								<td class="al_right">{{ invoice.total_amount | toCurrency }}</td>
								<td class="al_left">{{ invoice.remark }}</td>
								<td class="al_left">{{ invoice.description }}</td>
							</tr> -->
						</tbody>
					</table>
				</div>
			</div>

			<br />

			<div class="view_bottom_bt">
				<a href="javascript:;" id="save" type="button" class="gray_bt" @click="close()">Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/table_box.css';
import { apiSelectInvoiceList } from '@/api/sales/invoice.js';
import AC from '@/components/common/AC';

export default {
	data: function() {
		return {
			invoice_type: 'S',
			status_code: 'I',

			keyword: '',
			class_code: null,

			invoices: [],
		};
	},
	props: {
		initialShipToCode: String,
	},
	computed: {
		filteredInvoices() {
			var filterWord = this.keyword.trim().toUpperCase();
			if (filterWord)
				return this.invoices.filter(
					i => (i.so_dn && i.so_dn.toUpperCase().indexOf(filterWord) >= 0) || (i.invoice_dn && i.invoice_dn.toUpperCase().indexOf(filterWord) >= 0) || (i.invoice_amount > 0 && i.invoice_amount.toString().startsWith(filterWord)),
				);
			else return this.invoices;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		AC,
	},
	methods: {
		reset() {
			this.class_code = null;
			this.search();
		},
		selectACItems(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_master/acItemList?company_id=' + this.user.company_id + '&active_only=false&keyword=' + input;
			return url;
		},
		selectACItem(i) {
			//console.log(i.selectedObject);
			//this.item_id = i.selectedObject.item_id;
			//this.search();
			if (i.selectedObject.class_code) {
				this.class_code = i.selectedObject.class_code;
				this.search();
			} else {
				this.class_code = null;
			}
		},
		search() {
			this.selectInvoices();
		},
		// selectRow(user) {
		// 	if (this.selectedUserIds.includes(user.user_id)) {
		// 		const index = this.selectedUserIds.indexOf(user.user_id);
		// 		if (index > -1) {
		// 			this.selectedUserIds.splice(index, 1);
		// 		}
		// 	} else this.selectedUserIds.push(user.user_id);
		// },
		async selectInvoices() {
			if (!this.initialShipToCode) return;

			const { data } = await apiSelectInvoiceList({
				paging_yn: 'N',

				invoice_type: this.invoice_type,
				status_code: this.status_code,
				ship_to_code: this.initialShipToCode,

				class_code: this.class_code,
			});

			this.invoices = data.invoiceList;
		},

		selectRow(invoice) {
			//console.log(invoice);
			//this.$emit('set-invoice', invoice);
			//this.close();
			this.$emit('close', invoice);
		},

		close() {
			this.$emit('close');
		},
	},
	created() {
		this.selectInvoices();
		//this.selectPartners();
		//this.item = _.cloneDeep(this.selectedItem);
		// if (this.initialKeyword) {
		// 	this.keyword = this.initialKeyword;
		// 	this.selectSalesOrders();
		// }
	},
	mounted() {},
};
</script>

<style></style>
